import { action, runInAction, observable } from 'mobx';
import { Policy } from '../../orders/api/policyApi';
import vehiclesController from './controller';
import insurancesController from '../../insurances/store/controller';
import { VehicleOwnerInterface, VehicleInterface, InsuranceInterface, VehicleRequestInterface } from '../api/vehicleApi';
export interface VehicleStore {
  vehicle: VehicleInterface,
  vehicleRequest: VehicleRequestInterface
  vehicleInsurances: InsuranceInterface[],

  policies: Policy[],
  policiesByVehicleId: string,
  currentVehiclePolicy: any,
  vehicleOwners: VehicleOwnerInterface[],
  vehicleOwnersByVehicleId: string,
  vehicleOwnersLoading: boolean,
  vehicleOwnersShowDeletedClients: boolean,
  vehicleOwnersShowDeletedRelations: boolean,
  error: string,
}

const initialValues: VehicleStore = {
  vehicle: null,
  vehicleRequest: null,
  vehicleInsurances: [],

  policies: [],
  policiesByVehicleId: null,
  currentVehiclePolicy: null,
  vehicleOwners: [],
  vehicleOwnersByVehicleId: null,
  vehicleOwnersLoading: false,
  vehicleOwnersShowDeletedClients: true,
  vehicleOwnersShowDeletedRelations: true,
  error: null,
};

export const vehicleStore = observable(initialValues);

export const vehicleActions = {

  getVehicle: async (request: VehicleRequestInterface) => {
    try {
      runInAction(() => {
        vehicleStore.vehicleRequest = request;
      });
      const response = await vehiclesController.getClientVehicle(request);
      runInAction(() => {
        vehicleStore.vehicle = response.data;
        vehicleStore.vehicleInsurances = response.data?.insurances || [];
      });
    } catch (err) {
      vehicleStore.error = err.message || err;
      vehicleStore.vehicleRequest = null;
    }
  },

  saveVehicle: async () => {
    if (vehicleStore.vehicle?.updated) {
      try {
        const response = await vehiclesController.putClientVehicle(vehicleStore.vehicle);
        runInAction(() => {
          vehicleStore.vehicle = response.data;
          vehicleStore.vehicleInsurances = response.data?.insurances || [];
        });
      } catch (err) {
        vehicleStore.error = err.message || err;
        vehicleStore.vehicleRequest = null;
      }
    };
  },

  isVehicleUpdate: ():boolean => {
    return vehicleStore.vehicle?.updated;
  },

  // ВНИМАНИЕ !
  // Функция ниже адаптирована под изменение марки и модели авто в заявке эвакуации
  // и в заявке Урегулирования убытков
  // (там и применяется)
  // не используй где-то ещё
  setVehicle: action((request: VehicleInterface) => {
    if (!vehicleStore?.vehicle?.id) return;
    if ((vehicleStore?.vehicle?.makeId === request?.makeId)
       && (vehicleStore?.vehicle?.modelId === request?.modelId)
       && (vehicleStore?.vehicle?.vin === request?.vin)
        && (vehicleStore?.vehicle?.yearOfIssue === request?.yearOfIssue)
    ) return
    vehicleStore.vehicle = { ...request, updated: true };
  }),

  clearVehicle: async () => {
    vehicleStore.vehicle = null;
    vehicleStore.vehicleRequest = null;
    vehicleStore.vehicleInsurances = [];
  },

  setPolicies: action((policies: Policy[]) => {
    vehicleStore.policies = policies;
  }),

  setCurrentVehiclePolicy: action((policy: any) => {
    vehicleStore.currentVehiclePolicy = policy;
  }),

  clearChangedPolicies: action(() => {
    vehicleStore.policies = vehicleStore.policies.map(
      (v) => { return { ...v, created: false, deleted: false, updated: false }; }
    );
  }),

  getPolicies: async (vehicleId: string) => {
    try {
      vehicleStore.policiesByVehicleId = vehicleId;
      const response = await insurancesController.getVehicleInsurancePolicies({
        vehicleId,
      });
      runInAction(() => {
        vehicleStore.policies = response.data;
      });
    } catch (err) {
      vehicleStore.error = err.message || err;
      vehicleStore.policiesByVehicleId = null;
    }
  },

  getVehicleOwners: async (vehicleId: string) => {
    try {
      vehicleStore.vehicleOwnersByVehicleId = vehicleId;
      vehicleStore.vehicleOwnersLoading = true;
      const response = await vehiclesController.getVehicleOwners({
        vehicleId,
        showDeletedClients: vehicleStore.vehicleOwnersShowDeletedClients,
        showDeletedRelations: vehicleStore.vehicleOwnersShowDeletedRelations,
      });

      vehicleStore.vehicleOwners = response.data;
    } catch (err) {
      vehicleStore.error = err.message || err;
      vehicleStore.vehicleOwnersByVehicleId = null;
    } finally {
      vehicleStore.vehicleOwnersLoading = false;
    }
  },

  setVehicleOwnersShowDeletedClients: action(() => {

    vehicleStore.vehicleOwnersShowDeletedClients = !vehicleStore.vehicleOwnersShowDeletedClients;
  }),

  setVehicleOwnersShowDeletedRelations: action(() => {

    vehicleStore.vehicleOwnersShowDeletedRelations = !vehicleStore.vehicleOwnersShowDeletedRelations;
  }),

  clearVehicleOwners: async () => {
    vehicleStore.vehicleOwnersLoading = false;
    vehicleStore.vehicleOwnersByVehicleId = null;
    vehicleStore.vehicleOwners = [];
  },

  // Диаметр колёс по авто.
  // Значение нужно только вызывающей форме (Formik parsedDetails),
  // поэтому в store не складывается — ответ возвращается наружу.
  // Бэк может ответить 404/null/пустым массивом — ответственность за
  // обработку таких ответов лежит на вызывающей стороне.
  getVehicleWheelDiameter: async (vehicleId: string, options?: { silentToast?: boolean }) => {
    return vehiclesController.getVehicleWheelDiameter(vehicleId, options);
  },
};
